/**
 * @generated SignedSource<<652e25417edeeb347d61066d58821dad>>
 * @relayHash b4191b2266bb7ed6d095f2ada68fce54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 650b20eeee7be0757386b58e521734bdcf57b15a5601f0010de24eec444f16e3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessApprovalsAppMemoQuery } from './JiraBusinessApprovalsAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessApprovalsAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "650b20eeee7be0757386b58e521734bdcf57b15a5601f0010de24eec444f16e3",
    "metadata": {},
    "name": "JiraBusinessApprovalsAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
